module.exports = __webpack_public_path__ + "static/media/1024553.d36bf862.jpg";